import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/auth';
import { CookieConsent } from './components/CookieConsent';
import '@fontsource-variable/archivo/wdth.css';
import './index.css';
import './styles/buttons.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthProvider>
        <App />
        {/* Mounted beside App, not inside it, so the banner shows on every
            screen App can render — signed out, onboarding, and legal pages —
            without repeating it across App's return branches. */}
        <CookieConsent />
    </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
